import { DateTime } from "luxon";
import { AlertCircle } from "lucide-react";
import type { BannerStatus } from "@services/banners/commands/cmdListBanners";
import { formatEt } from "@/shared/utils/date-utils/easternTime";

/** The banner in the way: from the editor's live check (with a status) or a 409's details.conflict (without). */
export interface OverlappingBanner {
    message: string;
    starts_at: string | null;
    ends_at: string | null;
    status?: BannerStatus;
}

/** Names the Live or Scheduled banner whose window these dates overlap (MPN-2171 design copy). */
export default function OverlapAlert({ conflict }: { conflict: OverlappingBanner }) {
    // A 409's conflict has no status; it is Live when it has already started.
    const live = conflict.status
        ? conflict.status === "Live"
        : !!conflict.starts_at && DateTime.fromISO(conflict.starts_at) <= DateTime.now();
    const window = conflict.ends_at
        ? `${formatEt(conflict.starts_at)} to ${formatEt(conflict.ends_at)}`
        : `${formatEt(conflict.starts_at)} until turned off`;
    return (
        <div role="alert" className="alert alert-danger banner-editor__conflict">
            <AlertCircle size={16} aria-hidden="true" className="flex-none" />
            <span>
                These dates overlap the {live ? "live" : "scheduled"} banner "{conflict.message}" ({window}). One banner can be
                live at a time, so change the dates or turn that banner off first.
            </span>
        </div>
    );
}
